import styled from 'styled-components'

export const Wrapper = styled.div`
  .description-subtitle {
    ${({ theme }) => theme.below.tablet`
      font-size: ${({ theme }) =>
        theme.typography.mobile.title.title4.fontSize}px;
      line-height: ${({ theme }) =>
        theme.typography.mobile.title.title4.lineHeight}px;
    `}
  }
`
